import sanitizeFilename from 'sanitize-filename'

export const DOWNLOAD_FILENAME_MAX_LENGTH = 128

export const downLoadFile = (
  data: Blob,
  type: BlobType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  filename: string,
) => {
  const fileURL = window.URL.createObjectURL(
    new Blob([data], {
      type,
    }),
  )
  const link = document.createElement('a')
  link.href = fileURL
  link.download = sanitizeFilename(filename).substring(0, DOWNLOAD_FILENAME_MAX_LENGTH)
  link.click()
  // Revoke on the next tick: Safari can abort a download whose blob url is revoked synchronously.
  setTimeout(() => window.URL.revokeObjectURL(fileURL))
}
